__turbopack_context__.v({
  "active": "SearchTabs-module-scss-module__Do2CHq__active",
  "count": "SearchTabs-module-scss-module__Do2CHq__count",
  "empty": "SearchTabs-module-scss-module__Do2CHq__empty",
  "label": "SearchTabs-module-scss-module__Do2CHq__label",
  "separator": "SearchTabs-module-scss-module__Do2CHq__separator",
  "tab": "SearchTabs-module-scss-module__Do2CHq__tab",
  "tabWrapper": "SearchTabs-module-scss-module__Do2CHq__tabWrapper",
  "tabs": "SearchTabs-module-scss-module__Do2CHq__tabs",
});
